<div class="password-strength">
  <span i18n>Password strength: {{ strength }}</span>
  <div class="strength-meter">
    <div
      class="strength-bar"
      [ngClass]="{
        weak: strengthLevel === 'weak',
        moderate: strengthLevel === 'moderate',
        strong: strengthLevel === 'strong'
      }"
    ></div>
  </div>
  <ul class="password-requirements">
    <li [ngClass]="{ valid: criteria.hasMinLength }" i18n>At least 12 characters</li>
    <li [ngClass]="{ valid: criteria.hasLowercase }" i18n>At least one lowercase letter</li>
    <li [ngClass]="{ valid: criteria.hasUppercase }" i18n>At least one uppercase letter</li>
    <li [ngClass]="{ valid: criteria.hasNumber }" i18n>At least one number</li>
    <li [ngClass]="{ valid: criteria.hasSpecialChar }" i18n>At least one special character</li>
  </ul>
</div>
